import { render, staticRenderFns } from "./SubmittedEmdWaiting.vue?vue&type=template&id=f4510a8c&scoped=true&"
import script from "./SubmittedEmdWaiting.vue?vue&type=script&lang=js&"
export * from "./SubmittedEmdWaiting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4510a8c",
  null
  
)

export default component.exports